import { Pipe, PipeTransform } from '@angular/core';
import { QueueAssignmentTenant } from '@app/modules/identification/models/Rules/Response/queue-assignment.model';

@Pipe({
  name: 'filterQueueTenant',
  standalone: false,
})
export class FilterQueueTenantPipe implements PipeTransform {
  transform(queueAssignmentTenants: QueueAssignmentTenant[], templateId: number): string {
    if (templateId == null) {
      return null;
    }

    return queueAssignmentTenants
      .filter((t) => t.templateId === templateId)
      .map((t) => t.tenantName)
      .join(', ');
  }
}
